export default {
  "welcome": {
    "welcome-to": "Добро пожаловать в",
    "one-philly": "Одна Филадельфия,",
    "united-city": "Единый город!",
  },
  "city-offices": {
    "city-offices-title": "Городские офисы",
    "city-offices-text-1": "Городские офисы открыты в обычное рабочее время. Некоторые услуги предоставляются онлайн или по предварительной записи. Чтобы узнать больше, ",
    "city-offices-text-2": "обратитесь в интересующий вас отдел.",
    "city-offices-closure-text": "",
    "trash-title": "Мусор и переработка",
    "trash-text-1": "Вывоз мусора и мусора осуществляется по праздничному графику. Отправляйте материалы на один день позже обычного дня.",
    "trash-text-2": "Чтобы узнать больше, ",
    "trash-text-3": "ознакомьтесь с графиком отпусков.",
    "trash-closure-text": "",
  },
  "services": {
    "trash": "День найди свой мусор",
    "bill": "Оплатите счет",
    "jobs": "Изучите работу в городе",
    "property": "Поиск недвижимости",
    "taxes": "Подайте и уплатите городские налоги",
    "recycle": "Перерабатывайте осенние листья",
    "visit": "Посетите заключенного",
    "license": "Получите лицензию",
    "popular-services": "Популярные сервисы",
    "jump-to-all-services": "Перейти ко всем сервисам",
    "services-by-topic": "Услуги по темам",
    "see-all-services": "Смотреть все услуги",
    "alerts": "Подпишитесь на экстренные оповещения",
  },
  "tools": {
    "parks-finder": "поиск парков и зон отдыха",
    "contracts": "центр контрактов",
    "school-time-activity": "искатель активности во внешкольное время",
    "food-meal": "бесплатный поиск еды и еды",
    "atlas": "атлас",
    "primary": "поиск первичной медико-санитарной",
    "eclipse": "затм",
    "mail-vote-remind": "письмо в напоминании о голосовании",
    "street-smart": "StreetSmartPHL",
    "commonly-used-tools": "Часто используемые инструменты",
    "see-all-tools": "См. все инструменты",
  },
  "news": {
    "featured-news": "Избранные новости",
    "see-all-news": "Смотреть все новости",
  },
  "311": {
    "report-311": "Помогите сделать Филадельфию самым безопасным, чистым и зеленым крупным городом страны. Сообщайте в Philly311 о пустующих участках, граффити, заброшенных автомобилях и многом другом.",
    "report-problem": "СООБЩИТЬ О ПРОБЛЕМЕ",
    "track-request": "ОТСЛЕЖИВАТЬ ЗАПРОС",
    "ask-question": "ЗАДАЙТЕ ВОПРОС",
  },
  "stay-connected": {
    "stay-connected": "Оставайтесь на связи",
    "sign-up-email": "Подпишитесь на рассылку новостей из Филадельфии по электронной почте",
    "sign-up": "Зарегистрируйтесь",
  },
  "footer": {
    "elected-officials": "Выборные чиновники",
    "mayor": "Мэр",
    "city-council": "Городской совет",
    "courts": "Суды",
    "district-attorney": "Окружной прокурор",
    "city-controller": "Городской контролер",
    "sheriff": "Шериф",
    "city-commissioners": "Городские комиссары",
    "register-wills": "Реестр завещаний",
    "open-govt": "Открытое правительство",
    "code-charter": "Филадельфийский кодекс и устав",
    "city-records": "Городские рекорды",
    "city-agency-regs": "Правила работы городских агентств",
    "executive-orders": "Исполнительные указы",
    "honesty-govt": "Честность в правительстве",
    "voting-elections": "Голосование и выборы",
    "open-data": "Открытые данные",
    "org-chart": "Схема городской организации",
    "explore-phila": "Исследуйте Филадельфию",
    "visit-phila": "Посетите Филадельфию",
  },
  "clean-green": {
    "clean-green": "Чистый и зеленый ",
    "clean-green-statement": "Наш город объединяется, чтобы сделать Филадельфию самым безопасным, чистым и зеленым крупным городом страны с экономическими возможностями для всех. Следуйте общегородской стратегии, направленной на решение проблем качества жизни в каждом районе.",
    "blocks-swept": "Заметанные кварталы",
    "abandoned-autos": "Брошенные автомобили удалены",
    "properties-cleaned": "Свойства очищены и герметизированы",
    "graffiti-removed": "Граффити удалено",
    "see-all-clean-green": "СМОТРЕТЬ ВСЕ ЧИСТЫЕ И ЗЕЛЕНЫЕ",
  },
  "mayor": {
    "mayor-details": "Cherelle L. Parker является 100-м мэром Филадельфии и первой женщиной, занявшей эту должность за 341 год. Она всю жизнь прожила в городе и каждый день борется за филадельфийцев.",
    "learn-more": "Узнайте больше",
  },
  "city-council": {
    "city-council": "Городской совет",
    "district-council-member": "Член окружного совета",
    "council-member-al":  "Член Совета по особым поручениям",
    "council-president": "Президент Совета",
    "dep-majority-whip": "Член депутатского большинства",
    "majority-whip": "Кнут большинства",
    "minority-leader": "Лидер меньшинства",
    "minority-whip": "Кнут меньшинства",
    "majority-leader": "Лидер большинства",
  }, 
  "philly-stat-360": {
    "ps360": "Штат Филадельфия 360",
    "data-subheader": "Превращение данных в действия для наших сообществ.",
  },
};